module.exports = __webpack_public_path__ + "bd15c9255427a543a8760c28d45f8496.png";